import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const actions = {

}
const mutations = {
    //切换语言
    switchLang(state,value){
        state.currentLang  = value
    },
    //切换下标
    switchHeaderIndex(state,value){
       state.headerIndex = value
    },
     //切换新闻
     switchNews(state,value){
        state.newsFlag = value
     }
}
const state = {
    currentLang:'Cn',//当前语言
    headerIndex:'1',//header菜单当前下标
    newsFlag:0,//新闻标识 0,//企业新闻 1，行业新闻
}
export default new Vuex.Store({
    actions,
    mutations,
    state
})


// WEBPACK FOOTER //
// ./src/store/index.js